import React from 'react';
import { useTranslation } from 'react-i18next';
import { keyMap } from '@locales/lokalise/keyMap';
import { handleError } from 'utils/errors';
import { TableExportProps } from '../types';

const TableExport = (props: TableExportProps) => {
  const { exportAPI } = props;
  const { i18n } = useTranslation();

  const onDownload = () => {
    const { exportAPI } = props;
    const form = document.createElement('form');

    form.method = 'POST';
    form.action = exportAPI;
    document.body.appendChild(form);

    try {
      form.submit();
    } catch (error) {
      handleError('Export failed', error);
      return false;
    } finally {
      document.body.removeChild(form);
    }
  };

  return (
    <form>
      <div className="table-filter table-export">
        {exportAPI && (
          <button type="button" className="form__button basic--button" onClick={onDownload}>
            {i18n.t(keyMap.formsExport)}
          </button>
        )}
      </div>
    </form>
  );
};

export default TableExport;
